import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export { getPeripheralTypeLabel, PERIPHERAL_TYPE_VALUES } from '../../../peripheral-type-i18n'

export interface QueryParams {
  /** 终端id */
  device_id: string
  /** 设备状态 1：启动，2：禁用，3：全部（默认） */
  peripheral_status: number
  /** 时间范围 1：全部 ，2：最近24小时 （默认），3：最近7天 ，4：近一个月 */
  time_range: number
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
}

export interface EquipmentItem {
  /** 存储设备ID */
  peripheral_id: string
  /** 设备类型 */
  peripheral_type: string
  /** 设备名称 */
  peripheral_name: string
  /** 设备状态 1：启动，2：禁用 */
  peripheral_status: string
  /** 设备接入时间 */
  access_time: number
}

@Injectable()
export default class UsbTerminalService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getEquipmentList (data: QueryParams) {
    return this.http.post<{
      /** 设备接入信息列表 */
      list: EquipmentItem[]
      /** 总数 */
      total: number
    }>('/peripheralcontrol/view/terminal/access-records/get', data)
  }
}
